import { render, staticRenderFns } from "./Allocate.vue?vue&type=template&id=366b8bd4&scoped=true&"
import script from "./Allocate.vue?vue&type=script&lang=js&"
export * from "./Allocate.vue?vue&type=script&lang=js&"
import style0 from "./Allocate.vue?vue&type=style&index=0&id=366b8bd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366b8bd4",
  null
  
)

export default component.exports